// extracted by mini-css-extract-plugin
module.exports = {"container":"RecentNewsItem_container__3R3ou","styleFixed":"RecentNewsItem_styleFixed__25kAA","title":"RecentNewsItem_title__10o5J","time":"RecentNewsItem_time__15GWd"};